<template>
  <edit-modal
    caption="Een gebruiker toegang geven tot een account"
    :isActive="isActive">
    <div class="field">
      <div class="control">
        <select-wrapper
          :value="userId"
          :options="myUsers"
          @input="update"
          placeholder="Selecteer een gebruiker"
        ></select-wrapper>
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="close"
      :disabled="!valid">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  components: {
    EditModal,
    SaveButtons,
    SelectWrapper
  },
  data () {
    return {
      itemId: null,
      userId: null,
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      users: 'users/users'
    }),
    myUsers () {
      return this.users.map((user) => {
        return {
          label: `${user.firstname} ${user.lastname}`,
          value: user.id
        }
      })
    },
    valid () {
      return this.userId !== null
    }
  },
  created () {
    bus.$on('selectUser', (payload) => {
      this.itemId = payload
      this.open()
    })
  },
  methods: {
    open () {
      this.isActive = true
    },
    close () {
      this.itemId = this.userId = null
      this.isActive = false
    },
    save () {
      this.$store.dispatch('items/grant', {
        itemId: this.itemId,
        userId: this.userId
      })

      this.close()
    },
    update (userId) {
      this.userId = userId
    }
  }
}
</script>

<style scoped>
  p.select, select {
     width: 100%;
  }
</style>
